
const digest = 'd231729a521e1a9992c90521fd2959b1136655120d97465a72a3c993388e4cd1';
const classes = {"wrapper":"_wrapper_9va04_1","date":"_date_9va04_10","name":"_name_9va04_15","content":"_content_9va04_20","attachments":"_attachments_9va04_26","title":"_title_9va04_32","recipients":"_recipients_9va04_37"};
const css = `._wrapper_9va04_1 {
  display: flex;
  padding: 24px;
  flex-direction: column;
  background-color: #fbfbfd;
  border: 1px solid #eaedf3;
  margin-top: 10px;
  font-family: Rubik, "sans-serif";
}
._wrapper_9va04_1 ._date_9va04_10 {
  font-weight: 400;
  font-size: 12px;
  color: #3e3f42;
}
._wrapper_9va04_1 ._name_9va04_15 {
  font-weight: 500;
  font-size: 12px;
  color: #000000;
}
._wrapper_9va04_1 ._content_9va04_20 {
  margin-top: 10px;
  font-weight: 400;
  font-size: 16px;
  color: #3e3f42;
}
._wrapper_9va04_1 ._attachments_9va04_26 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
}
._wrapper_9va04_1 ._attachments_9va04_26 ._title_9va04_32 {
  font-weight: 500;
  font-size: 14px;
  color: #1665d8;
}
._wrapper_9va04_1 ._recipients_9va04_37 {
  font-size: 12px;
  display: flex;
  flex-direction: row;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  